import { render, staticRenderFns } from "./StepInitStart.vue?vue&type=template&id=0c46c746&scoped=true&"
import script from "./StepInitStart.vue?vue&type=script&lang=js&"
export * from "./StepInitStart.vue?vue&type=script&lang=js&"
import style0 from "./StepInitStart.vue?vue&type=style&index=0&id=0c46c746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c46c746",
  null
  
)

export default component.exports